<div id="print-section" class="contract">
  <div class="contract__title">
    <h1>{{ tipoContrato }}</h1>
  </div>
  <div class="contract__personal-data">
    <table class="contract__table">
      <tr>
        <td>
          <p>
            Por este instrumento particular, de um lado,
            <strong>NOME:</strong> {{ proprietario?.name }},
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>CPF:</strong> {{ proprietario?.cpf | mask: '000.000.000-00' }},
            <strong>RG:</strong> {{ proprietario?.rg?.number || '' }}, <strong>EMISSOR/UF: </strong>
            {{ proprietario?.rg?.issuer || '' }}/{{ proprietario?.rg?.state || ''}}
          </p>
        </td>
      </tr>
      <tr *ngIf="(proprietario?.maritalStatus === estadoCivil.MARRIED) && conjuge ">
        <td>
          <p>
            <strong>CÔNJUGE/COMPANHEIRO:</strong> {{ conjuge?.name }},
            <strong>CPF:</strong> {{ conjuge?.cpf | mask: '000.000.000-00' }}
          </p>
        </td>
      </tr>
      <tr *ngIf="cadastro?.reurbModalidade">
        <td>
          <p>
            <strong>Condições REURB:</strong> Renda Familiar menor que 5(cinco) salários mínimos
            e não ter sido beneficiado pela REURB anteriormente. <br />
            ( {{ cadastro.reurbModalidade === reurbModalidade.REURB_S ? 'X' : '' }} ) REURB–S ou
            ( {{ cadastro.reurbModalidade === reurbModalidade.REURB_E ? 'X' : '' }} ) REURB–E
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Qual o segmento de uso do imóvel:</strong>
            ( {{ imovel?.usage === imovelTipo.RESIDENTIAL ? 'X' : '' }} ) Residencial
            ( {{ imovel?.usage === imovelTipo.COMMERCIAL ? 'X' : '' }} ) Comercial
            ( {{ imovel?.usage === imovelTipo.MIXED ? 'X' : '' }} ) Misto
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Estado Civil:</strong>
            ( {{ proprietario?.maritalStatus === estadoCivil.MARRIED ? 'X' : '' }} ) Casado(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.SINGLE ? 'X' : '' }} ) Solteiro(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.WIDOWED ? 'X' : '' }} ) Viúvo(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.SEPARATED ? 'X' : '' }} ) Separado(a)
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>E-mail: </strong> {{ proprietario?.email }}
            <strong>Telefone: </strong>
            {{ proprietario?.phones?.cellphone ? (proprietario.phones.cellphone | mask: '(00) 00000-0000') : ''}}
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Observações (situação jurídica, endereço, quadra e lote): </strong>
          </p>
        </td>
      </tr>
    </table>

    <p>Doravante denominados <strong>"{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}"</strong>; e, de outro lado,
      <strong>USU CAMPEÃO INCORPORAÇÃO, LOTEAMENTO E URBANIZAÇÃO SOCIAL LTDA.</strong>, pessoa jurídica de direito
      privado, com SEDE na Rua Cláudio Soares 72, conj. 615 Pinheiros, São Paulo – SP, inscrita no CNPJ/MF, sob o nº
      <strong>36.174.049/0001-08</strong> e FILIAL Rua José Rodrigues Pereira 514, Estoril, Belo Horizonte – MG sob o nº
      <strong>36.174.049/0002-99</strong>, neste ato representada
      de acordo com seus atos constitutivos, doravante denominado <strong>"USUCAMPEÃO"</strong>, celebram o presente
      <strong>{{ tipoContrato }}</strong>, regido pelas seguintes cláusulas:
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Primeira – OBJETO</h2>

    <p>
      <ng-container *ngIf="possuiAverbacao; else semAverbacao11">
        <strong>1.1.</strong> Este Contrato estabelece as condições pelas quais a <strong>USUCAMPEÃO</strong>
        prestará {{ conjuge ? 'aos' : 'ao' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
        serviços de regularização fundiária “REURB” e de “Averbação Edilícia”, em três etapas, que poderão ser
        realizadas de forma concomitante ou individualmente, visando realizar os procedimentos necessários para
        obtenção da titulação da unidade imobiliária da qual {{ conjuge ? 'os' : 'o' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> detém a posse, nos termos da Lei Federal
        13.465/17 e Decreto Federal n° 9.310/2018.
      </ng-container>

      <ng-template #semAverbacao11>
        <strong>1.1.</strong> Este Contrato estabelece as condições pelas quais a <strong>USUCAMPEÃO</strong> prestará
        serviços de
        regularização fundiária “REURB”, visando realizar os procedimentos necessários para regularização do núcleo
        urbano informal no qual está situado o imóvel {{ conjuge ? 'dos' : 'do' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> e para obtenção da titulação da unidade
        imobiliária da qual {{ conjuge ? 'os' : 'o' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> detém a posse, nos termos da Lei Federal
        13.465/17 e Decreto Federal n° 9.310/2018.
      </ng-template>
    </p>

    <ul>
      <li>
        <strong>1.1.1.</strong> Os Serviços de REURB serão realizados conforme as seguintes etapas:
        <ul>
          <li>
            <strong>a.</strong> PRIMEIRA ETAPA: coleta de dados e pré-análise, equivalente a 10% (dez por cento) dos
            serviços prestados;
          </li>
          <li>
            <strong>b.</strong> SEGUNDA ETAPA: engenharia, memorial do perímetro, levantamento planialtimétrico
            cadastral do núcleo e projeto urbanístico, equivalente a 30% (trinta por cento) dos serviços prestados; e
          </li>
          <li>
            <strong>c.</strong> TERCEIRA ETAPA: protocolo junto ao ente municipal da REURB e entrega da Certidão de
            Regularização Fundiária (CRF), equivalente a 60% (sessenta por cento) dos serviços prestados.
          </li>
        </ul>
      </li>

      <li *ngIf="cadastro.averbacao">
        <strong>1.1.2.</strong> Os Serviços de Averbação Edilícia serão realizados conforme as seguintes etapas:
        <ul>
          <li><strong>a.</strong> PRIMEIRA ETAPA: coleta de dados e pré-análise;</li>
          <li><strong>b.</strong> SEGUNDA ETAPA: medição da área da área construída e envio da planta de anuência; e
          </li>
          <li>
            <strong>c.</strong> TERCEIRA ETAPA: protocolo junto ao Oficial de Registro de Imóveis e emissão da
            matrícula com a averbação da construção.
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <div class="clause">
    <h2>Cláusula Segunda – RESPONSABILIDADE DAS PARTES</h2>
    <p><strong>2.1.</strong> São obrigações {{ conjuge ? 'dos' : 'do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ contratoSemPagamento ? '' : 'efetuar o pagamento na forma da Cláusula Terceira e' }} fornecer todas as
      informações e documentos solicitados pela USUCAMPEÃO na execução dos Serviços.
    </p>
    <p>
      <strong>2.2.</strong> {{ conjuge ? 'Os' : 'O' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'comprometem-se' : 'compromete-se' }} a apresentar à USUCAMPEÃO no prazo de até 15 dias corridos
      todos e quaisquer documentos que forem solicitados, incluindo assinaturas em documentos, declarações e
      procurações, sob pena de não ser incluído nas listagens a serem enviadas para os entes municipais e
      {{ possuiAverbacao ? 'registradores imobiliários' : 'registros de imóveis' }}.
    </p>
    <p *ngIf="contratoSemPagamento">
      <strong>2.3.</strong> Em caso de transmissão da unidade imobiliária a terceiros, seja a que título for,
      {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'se responsabilizam' : 'se responsabiliza' }} a informar imediatamente à <strong>USUCAMPEÃO</strong>
      para a devida formalização do instrumento particular de cessão dos direitos e obrigações aqui formalizados. A
      <strong>USUCAMPEÃO</strong> não se responsabilizará por erro referente à titulação da unidade decorrente da
      ausência da mencionada comunicação.
    </p>
    <p>
      <strong>{{ contratoSemPagamento ? '2.4.' : '2.3.' }}</strong> São obrigações da <strong>USUCAMPEÃO</strong> a
      execução dos Serviços constantes na Cláusula Primeira e no Anexo 1 (escopo do serviço).
    </p>
  </div>

  <div class="clause">
    <h2>
      Cláusula Terceira – {{ contratoSemPagamento && !possuiAverbacao ? 'GRATUIDADE DA PRESTAÇÃO DOS SERVIÇOS' :
      'REMUNERAÇÃO E FORMA DE PAGAMENTO' }}
    </h2>
    <ng-container *ngIf="possuiAverbacao; else semAverbacao31">
      <p><strong>3.1.</strong>A remuneração pelos serviços prestados é assim discriminada: </p>
      <ul>
        <li>
          <ng-container *ngIf="!cadastro?.semPagamento; else templateReurbAverbacaoSemPagamento31">
            <strong>3.1.1.</strong> Pelos Serviços de REURB, descritos no item 1.1.1., {{ conjuge ? 'os' : 'o' }}
            <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> {{ conjuge ? 'pagarão' : 'pagará' }} a
            quantia
            de {{ (cadastro?.valorReurb | currency: 'BRL') }}
            ({{cadastro.valorReurb | numeroExtenso: numeroExtensoTipo.MONETARIO}})
          </ng-container>

          <ng-template #templateReurbAverbacaoSemPagamento31>
            <strong>3.1.1.</strong> Pelos Serviços de REURB, descritos no item 1.1.1., serão prestados de forma gratuita
            pela <strong>USUCAMPEÃO</strong> {{ conjuge ? 'aos' : 'ao' }}
            <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
          </ng-template>
        </li>

        <li>
          <strong>3.1.2.</strong> Pelos Serviços de Averbação Edilícia, descritos no item 1.1.2.,
          {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
          {{ conjuge ? 'pagarão' : 'pagará' }} a quantia de {{ (cadastro?.valorAverbacao | currency: 'BRL') }}
          ({{cadastro.valorAverbacao | numeroExtenso: numeroExtensoTipo.MONETARIO}}).
        </li>
      </ul>

      <p *ngIf="!cadastro?.semPagamento"><strong>3.2.</strong> O valor total pelos serviços prestados (REURB + averbação
        edilícia) é de {{ (cadastro?.valorServico | currency: 'BRL') }}
        ({{cadastro.valorServico | numeroExtenso: numeroExtensoTipo.MONETARIO}}),
        {{ pagamentoAVista ? 'e será pago no ato de assinatura' : 'parcelado e/ou no ato de assinatura' }}
        deste contrato e nos termos descritos no <strong>ANEXO II – DISPOSIÇÕES FINANCEIRAS</strong>.
      </p>
    </ng-container>

    <ng-template #semAverbacao31>
      <p>
        <ng-container *ngIf="!contratoSemPagamento; else contratoSemPagamento31">
          <strong>3.1.</strong> Pela prestação dos Serviços, {{ conjuge ? 'os' : 'o' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> {{ conjuge ? 'pagarão' : 'pagará' }} <strong>o
            valor total de</strong> {{ cadastro?.valorServico | currency: 'BRL'}}
          ({{cadastro.valorServico | numeroExtenso: numeroExtensoTipo.MONETARIO}}),
          {{ pagamentoAVista ? 'no ato de assinatura' : 'parcelado e/ou no ato de assinatura' }} deste contrato e nos
          termos descritos no <strong>ANEXO II – DISPOSIÇÕES FINANCEIRAS.</strong>
        </ng-container>

        <ng-template #contratoSemPagamento31>
          <strong>3.1.</strong> Os serviços serão prestados de forma gratuita pela <strong>USUCAMPEÃO</strong>
          {{ conjuge ? 'aos' : 'ao' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
        </ng-template>
      </p>
    </ng-template>

    <p>
      <strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.3.' : '3.2.' }}</strong> Os direitos reais a serem
      atribuídos
      {{ conjuge ? 'aos' : 'ao' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, estarão definidos na
      Certidão de Regularização Fundiária, a ser expedida pela Prefeitura. Para ser beneficiário dos citados direitos e
      receber a titulação de sua unidade imobiliária, o nome e a unidade imobiliária {{ conjuge ? 'dos' : 'do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> deverá constar na CRF, tudo em
      conformidade com o artigo 41 e incisos da Lei 13.465/17. Assim sendo, fica {{ conjuge ? 'os' : 'o' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> {{ conjuge ? 'cientes' : 'ciente' }} de que, tanto
      seu nome como a descrição de sua unidade imobiliária, somente constarão da CRF com a quitação integral do preço
      pactuado conforme ANEXO II – DISPOSIÇÕES FINANCEIRAS. Com fulcro no parágrafo primeiro do artigo 14, da Lei
      13.465/17, A USUCAMPEÃO entregará, para a Prefeitura, todos os projetos necessários e previstos nos artigos 35 e
      36 da mesma lei, acompanhada da lista dos ocupantes de cada unidade imobiliária que tenham aderido ao presente
      instrumento; memorial descritivo de cada unidade e demais projetos de topografia e engenharia mencionados na
      Cláusula Primeira, 1.2.
      <ng-container *ngIf="!pagamentoAVista">
        Quando todos os projetos técnicos estiverem concluídos, ANTES de encaminhar para a
        Prefeitura, a USUCAMPEÃO entrará em contato com {{ conjuge ? 'os' : 'o' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> para oferecer as seguintes opções:
      </ng-container>
    </p>
    <ng-container *ngIf="!pagamentoAVista">
      <ul>
        <li>
          <strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.3.1. ' : '3.2.1. ' }}</strong> <u>Efetuar a
            quitação total do preço
            pactuado</u>. Neste caso, {{ conjuge ? 'os nomes dos' : 'o nome do' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> já {{ conjuge ? 'constarão' : 'constará' }}
          da primeira lista a ser apresentada para a Prefeitura inserir na CRF, a fim de que, após o registro da CRF,
          <u>seja aberta matrícula individualizada da unidade imobiliária em nome
            {{ conjuge ? 'dos' : 'do' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong></u>.
        </li>
        <li>
          <strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.3.2.' : '3.2.2.' }}</strong> Continuar pagando o
          preço de forma parcelada, como pactuado neste instrumento e no ANEXO II – DISPOSIÇÕES FINANCEIRAS.
          Neste caso, {{ conjuge ? 'os nomes dos' : 'o nome do' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> somente
          {{ conjuge ? 'serão informados' : 'será informado' }} para a Prefeitura após a quitação integral do preço, ou
          seja, após a finalização do parcelamento. Assim sendo, após a finalização do parcelamento, a USUCAMPEÃO
          informará a Prefeitura, solicitando que {{ conjuge ? 'os' : 'o' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
          {{ conjuge ? 'sejam inseridos' : 'seja inserido' }} em lista complementar da CRF, na forma do artigo 23, §6º
          da Lei 13.465/17 (cadastro complementar).
        </li>
        <li>
          <strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.3.3.' : '3.2.3.' }}</strong> Em ambos os casos, a
          unidade imobiliária será
          titulada em nome {{ conjuge ? 'dos' : 'do' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>,
          variando apenas o momento em que ocorrerá.
        </li>
        <li>
          <strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.3.4.' : '3.2.4.' }}</strong> A USUCAMPEÃO poderá,
          se entender viável, após
          análise técnica e financeira, dispensar
          a tramitação prevista no item anterior, já inserindo {{ conjuge ? 'os nomes dos' : 'o nome do' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> na primeira lista a ser apresentada para
          a Prefeitura.
        </li>
      </ul>
      <p><strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.4.' : '3.3.' }}</strong> Havendo impontualidade no
        cumprimento da obrigação
        {{ conjuge ? 'pelos' : 'pelo' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>,
        {{ conjuge ? 'estes incorrerão' : 'este incorrerá' }} em multa de 2% (dois por cento) sobre o valor em atraso
        corrigido e juros moratórios de 1% (um por cento) ao mês, sob o valor devido.
      </p>
    </ng-container>
    <p *ngIf="pagamentoAVista">
      <strong>{{ possuiAverbacao && !contratoSemPagamento ? '3.4.' : '3.3.' }}</strong> Observando o disposto no item
      acima,
      {{ conjuge ? ' os nomes dos' : ' o nome do' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>,
      já {{ conjuge ? 'constarão' : 'constará' }} na
      primeira lista a ser apresentada para a Prefeitura para a emissão da CRF, a fim de que quando apresentada ao
      competente registrador imobiliário, seja aberta a matrícula individualizada da unidade imobiliária
      {{ conjuge ? ' dos' : ' do' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Quarta – DOS DIREITOS AUTORAIS</h2>
    <p>{{ conjuge ? 'Ficam os' : 'Fica o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> cientes de
      que todos os projetos técnicos que serão apresentados para a Prefeitura, são de uso exclusivo da
      <strong>USUCAMPEÃO</strong>, a qual detém os direitos autorais sobre eles.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Quinta – DOS PRAZOS E OUTRAS CONDIÇÕES</h2>
    <p>
      <strong>5.1.</strong> O prazo para finalização de um processo de regularização fundiária junto à Prefeitura, com
      a expedição de Certidão de Regularização Fundiária, é estimado entre 18 a 24 meses, podendo variar para mais ou
      para menos dependendo da complexidade do processo e do tempo da Prefeitura para análise e aprovação dos projetos.
      Dessa forma, dentro desse prazo, está computado o tempo de análise, pelos técnicos da Prefeitura, dos projetos e
      documentos apresentados pela <strong>USUCAMPEÃO</strong>. Portanto, dependendo da agilidade da Prefeitura, a CRF
      poderá ser emitida antes desse prazo ou até depois do mesmo. Dessa forma, a <strong>USUCAMPEÃO</strong> não pode
      ser responsabilizada pela demora na análise dos projetos e documentos apresentados. O comprometimento da
      <strong>USUCAMPEÃO</strong>, em relação ao prazo para execução dos serviços, se resume ao acompanhamento após a
      entrega dos trabalhos.
    </p>
    <p>
      <strong>5.2.</strong> A <strong>USUCAMPEÃO</strong> declara que realizou, antes da celebração do presente
      contrato, estudo de viabilidade prévia, o qual demonstra que o núcleo reúne condições de ser regularizado pela lei
      13.465/17.
    </p>
    <p>
      <strong>5.3.</strong> A <strong>USUCAMPEÃO</strong> iniciará a elaboração dos projetos somente quando se atingir
      o número de adesões necessárias para cobertura do custo de todos os projetos e medidas necessárias para realização
      da REURB. Para essa finalidade, fica estipulado o prazo mínimo de 06 meses, contados da data da realização da
      celebração do primeiro contrato de prestação de serviços com os ocupantes do núcleo. Esse prazo poderá ser
      diminuído caso haja adesões em número suficiente antes do mesmo.
    </p>
    <p>
      <strong>5.4.</strong> A <strong>USUCAMPEÃO</strong> se compromete a responder as devolutivas e atender as
      exigências da Prefeitura durante a tramitação do processo no prazo máximo de 120 dias, prazo esse muitas vezes
      necessário para realização de adequações técnicas dos projetos.
    </p>
    <p *ngIf="!contratoSemPagamento || possuiAverbacao">
      <strong>5.5.</strong> Não está computado no prazo de 18 a 24 meses, o prazo de registro do processo de REURB
      junto ao Cartório de Registro de Imóveis. Em relação ao mesmo, a <strong>USUCAMPEÃO</strong> também se compromete
      a responder e atender as devolutivas no prazo máximo de validade da Prenotação Registral. Caso não seja possível a
      resposta por motivos técnicos, o atendimento da devolutiva deverá ser realizado através de nova prenotação, no
      prazo máximo de 120 dias.
    </p>
    <p>
      <ng-container *ngIf="possuiAverbacao; else semAverbacao56">
        <strong>5.6.</strong> Em caso de transmissão da unidade imobiliária a terceiros, seja a que título for,
        {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
        {{ conjuge ? 'se responsabilizam' : 'se responsabiliza' }} a informar imediatamente à
        <strong>USUCAMPEÃO</strong> para a devida formalização do instrumento particular de cessão dos direitos e
        obrigações aqui formalizados. A <strong>USUCAMPEÃO</strong> não se responsabilizará por erro referente à
        titulação da unidade decorrente da ausência da mencionada comunicação.
      </ng-container>

      <ng-template #semAverbacao56>
        <strong>{{ contratoSemPagamento ? '5.5.' : '5.6.' }}</strong> O Presente Contrato se refere exclusivamente ao
        serviço de regularização fundiária na esfera administrativa, tanto na Prefeitura como no Cartório de Registro de
        Imóveis.
      </ng-template>
    </p>

    <p *ngIf="!possuiAverbacao">
      <strong>{{ contratoSemPagamento ? '5.6.' : '5.7.' }}</strong> {{ conjuge ? 'Os' : 'O' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'poderão' : 'poderá' }} contratar, a qualquer momento, os serviços relativos à averbação da
      construção, cujas especificações, valores e emolumentos serão objeto de aditamento ao presente contrato.
    </p>

    <p>
      <strong>{{ possuiAverbacao || contratoSemPagamento ? '5.7' : '5.8.' }}</strong> Considerando que o processo de
      regularização fundiária deve demonstrar a realidade fática dos imóveis, todas as medições realizadas pela equipe
      técnica serão realizadas em conformidade com a realidade aos quais os imóveis se encontram, mesmo que a descrição,
      perímetro, áreas e construção estejam divergentes com os contratos de aquisição apresentados
      {{ conjuge ? 'pelos' : 'pelo' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
    </p>
    <p>
      <strong>{{ possuiAverbacao || contratoSemPagamento ? '5.8.' : '5.9.' }}</strong> Antes da apresentação dos
      documentos referentes à Prefeitura para emissão da CRF, será enviada através da plataforma
      <i>“Voce Pode Regularizar”</i> ou por meio eletrônico (e-mail ou WhatsApp) para conhecimento a denominada “planta
      de anuência”, devidamente acompanhada de memorial descritivo, que conterá as medidas individuais apuradas in loco
      do lote {{ conjuge ? 'dos' : 'do' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>. Havendo
      discordância com as medidas apresentadas a contestação deverá ser apresentada em <strong><u>15 dias corridos</u>.
        A ausência de manifestação acarretará em concordância com as medidas apresentadas.</strong>
    </p>
    <p *ngIf="possuiAverbacao || !contratoSemPagamento">
      <ng-container *ngIf="possuiAverbacao; else semAverbacao59">
        <strong>5.9.</strong> A averbação edilícia, por ser ato acessório, fica condicionada à aprovação e registro da
        REURB.
      </ng-container>

      <ng-template #semAverbacao59>
        <strong>5.10.</strong> Em caso de venda da unidade imobiliária a terceiros, {{ conjuge ? 'os' : 'o' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> se
        {{ conjuge ? 'responsabilizam' : 'responsabiliza' }} a informar imediatamente à <strong>USUCAMPEÃO</strong> para
        a devida formalização do instrumento particular de cessão dos direitos e obrigações aqui formalizados. A
        <strong>USUCAMPEÃO</strong> não se responsabilizará por erro referente à titulação da unidade decorrente da
        ausência da mencionada comunicação.
      </ng-template>
    </p>
    <p>
      <strong>{{ possuiAverbacao ? '5.10.' : contratoSemPagamento ? '5.9.' : '5.11.' }}</strong> Não estão contempladas
      neste contrato, despesas com tributos inerentes à unidade imobiliária, taxas/preços públicos municipais e
      emolumentos de cartórios.
    </p>
    <p>
      <strong>{{ possuiAverbacao ? '5.11.' : contratoSemPagamento ? '5.10.' : '5.12.' }}</strong> Não estão
      contemplados neste contrato, eventuais procedimentos judiciais que sejam necessários para a viabilização da
      regularização.
    </p>
    <p>
      <ng-container *ngIf="possuiAverbacao || !contratoSemPagamento; else semPagamentoTemplate513">
        <strong>{{ possuiAverbacao ? '5.12.' : '5.13.' }}</strong> Estão contemplados neste contrato, os procedimentos
        de
        dúvida junto ao Cartório de Registro de Imóveis, quando necessário.
      </ng-container>

      <ng-template #semPagamentoTemplate513>
        <strong>5.11.</strong> Nenhuma das partes poderá ser considerada como inadimplente de suas obrigações
        contratuais se tal fato for resultante de caso fortuito ou força maior.
      </ng-template>
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Sexta – RESCISÃO</h2>
    <p>
      <strong>6.1.</strong> Este Contrato poderá ser rescindido imotivadamente {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, desde que seja enviada
      notificação prévia, com <strong><u>antecedência mínima de 15 (quinze) dias</u></strong>, gerando as seguintes
      consequências:
    </p>
    <ul>
      <ng-container *ngIf="possuiAverbacao; else recisaoSemAverbacao">
        <li>
          <strong>6.1.1.</strong> Se a rescisão ocorrer por parte {{ conjuge ? 'dos' : 'do' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> durante a PRIMEIRA ETAPA citada na
          Cláusula Primeira, itens 1.1.1 e 1.1.2, alínea “a”, os seguintes valores deverão ser pagos à USUCAMPEÃO:
          <ul>
            <li>20% (vinte por cento) do valor global do contrato por multa contratual;</li>
            <li>10% (dez por cento) do valor global do contrato referente aos serviços da primeira etapa.</li>
          </ul>
        </li>

        <li>
          <strong>6.1.2.</strong> Se a rescisão ocorrer por parte {{ conjuge ? 'dos' : 'do' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> durante a SEGUNDA ETAPA citada na Cláusula
          Primeira, itens 1.1.1 e 1.1.2, alínea “b”, os seguintes valores deverão ser pagos à USUCAMPEÃO:
          <ul>
            <li>20% (vinte por cento) do valor global do contrato por multa contratual;</li>
            <li>10% (dez por cento) do valor global do contrato referente aos serviços da primeira etapa;</li>
            <li>20% (vinte por cento) do valor global do contrato referente aos serviços prestados na segunda etapa.
            </li>
          </ul>
        </li>
        <li>
          <strong>6.1.3.</strong> Se a rescisão ocorrer por parte {{ conjuge ? 'dos' : 'do' }}
          <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> após o protocolo de REURB junto a
          municipalidade, os seguintes valores deverão ser pagos à USUCAMPEÃO:
          <ul>
            <li>20% (vinte por cento) do valor global do contrato por multa contratual;</li>
            <li>10% (dez por cento) do valor global do contrato referente aos serviços da primeira etapa;</li>
            <li>20% (vinte por cento) do valor global do contrato referentes aos serviços prestados na segunda etapa;
            </li>
            <li>20% (vinte por cento) do valor global do contrato referentes aos custos da terceira etapa.</li>
          </ul>
        </li>
      </ng-container>

      <ng-template #recisaoSemAverbacao>
        <ng-container *ngIf="!contratoSemPagamento; else recisaoSemPagamento">
          <li>
            <strong>6.1.1.</strong> Se o requerimento de REURB já estiver protocolado junto à municipalidade:
            <ul>
              <li>
                <strong>6.1.1.1.</strong> Devolução de 80% do valor pago caso o protocolo tenha sido realizado sem
                qualquer
                documento que o acompanhe, sendo retido o percentual de 10% inerente ao início dos estudos técnicos e
                despesas administrativas;
              </li>
              <li>
                <strong>6.1.1.2.</strong> Devolução de 70% do valor pago se já elaborada a planta e memorial do
                perímetro
                do
                núcleo a ser regularizado, providência que demanda estudo fundiário específico;
              </li>
              <li>
                <strong>6.1.1.3.</strong> Devolução de 50% do valor pago se já elaborado , além da planta e memorial do
                perímetro, o Levantamento Planialtimétrico Cadastral do Núcleo;
              </li>
              <li>
                <strong>6.1.1.4.</strong> Devolução de 30% do valor pago se já elaborado, além das peças citadas no item
                anterior, o Projeto Urbanístico do núcleo;
              </li>
            </ul>
          </li>

          <li>
            <strong>6.1.2.</strong> Se o requerimento de REURB ainda não estiver protocolado junto à municipalidade:
            <ul>
              <li>
                <strong>6.1.2.1.</strong> Devolução de 90% do valor pago inerente ao início dos estudos técnicos e
                despesas
                administrativas;
              </li>
              <li>
                <strong>6.1.2.2.</strong> Devolução de 70% do valor pago se já elaborada a planta e memorial do
                perímetro
                do
                núcleo a ser regularizado, providência que demanda estudo fundiário específico;
              </li>
              <li>
                <strong>6.1.2.3.</strong> Devolução de 50% do valor pago se já elaborado , além da planta e memorial do
                perímetro, o Levantamento Planialtimétrico Cadastral do Núcleo;
              </li>
              <li>
                <strong>6.1.2.4.</strong> Devolução de 30% do valor pago se já elaborado, além das peças citadas no item
                anterior, o Projeto Urbanístico do núcleo;
              </li>
            </ul>
          </li>
        </ng-container>

        <ng-template #recisaoSemPagamento>
          <li>
            <strong>6.1.1.</strong> Se a rescisão ocorrer por parte {{ conjuge ? 'dos' : 'do' }}
            <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> durante a PRIMEIRA ETAPA citada na
            Cláusula Primeira, item 1.2, alínea “a”, será aplicada multa compensatória em prol da
            <strong>USUCAMPEÃO</strong> no valor de R$1.500,00 (um mil e quinhentos reais);
          </li>
          <li>
            <strong>6.1.2. </strong> Se a rescisão ocorrer por parte {{ conjuge ? 'dos' : 'do' }}
            <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> durante a SEGUNDA ETAPA citada na
            Cláusula Primeira, item 1.2, alínea “b”, será aplicada multa compensatória em prol da
            <strong>USUCAMPEÃO</strong> no valor de R$2.000,00 (dois mil reais);
          </li>
          <li>
            <strong>6.1.3.</strong>Se a rescisão ocorrer por parte {{ conjuge ? 'dos' : 'do' }}
            <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> durante a TERCEIRA ETAPA citada na
            Cláusula Primeira, item 1.2, alínea “c”, será aplicada multa compensatória em prol da
            <strong>USUCAMPEÃO</strong> no valor de R$6.000,00 (seis mil reais).
          </li>
        </ng-template>
      </ng-template>
    </ul>

    <p *ngIf="!contratoSemPagamento; else semPagamentoTemplate62">
      <strong>6.2.</strong> No caso de rescisão por motivo de indeferimento do processo administrativo de REURB pela
      Prefeitura, <strong>por fato não atribuível à USUCAMPEÃO,</strong> não haverá a restituição de nenhum dos valores
      pagos até o momento do indeferimento. A mesma condição se aplica em caso da negativa de registro do projeto de
      regularização fundiária por parte do Cartório de Registro de Imóveis, por fato também não atribuível à
      <strong>USUCAMPEÃO</strong>.
    </p>

    <ng-template #semPagamentoTemplate62>
      <p>
        <strong>6.2.</strong> {{ conjuge ? 'Os' : 'O' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, desde já está ciente e de acordo que a
        <strong>USUCAMPEÃO</strong> não poderá ser responsabilizada civil, criminal e administrativamente na ocorrência
        quaisquer uma dessas hipóteses:
      </p>

      <ul>
        <li><strong>a.</strong> Pela desistência do <strong>CONTRATANTE</strong>;</li>
        <li><strong>b.</strong> Por caso fortuito ou força maior;</li>
        <li><strong>c.</strong> Pelo indeferimento do processo administrativo junto à Prefeitura;</li>
        <li>
          <strong>d.</strong> Pela negativa de registro do projeto de regularização fundiária pelo Oficial de Registro
          de Imóveis.
        </li>
      </ul>
    </ng-template>
  </div>

  <div class="clause">
    <h2>Cláusula Sétima – DISPOSIÇÕES GERAIS</h2>
    <ng-container *ngIf="!possuiAverbacao && contratoSemPagamento; else semPagamentoTemplate7">
      <p>
        <strong>7.1.</strong> A USUCAMPEÃO poderá ceder o recebível para instituições financeiras, ficando expressamente
        autorizada para tanto {{ conjuge ? 'pelos' : 'pelo' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
      </p>
      <p>
        <strong>7.2.</strong> Nenhuma das Partes poderá ser considerada como inadimplente de suas obrigações contratuais
        se tal fato for resultante de caso fortuito ou força maior.
      </p>
      <p>
        <strong>7.3.</strong> O presente Contrato se refere exclusivamente ao serviço de regularização fundiária na
        esfera administrativa perante a Prefeitura e Oficiais de Registro de Imóveis.
      </p>
      <p>
        <strong>7.4.</strong> As obrigações aqui pactuadas ficam condicionadas ao pagamento do valor integral pactuado
        na
        Cláusula Terceira.
      </p>
    </ng-container>

    <ng-template #semPagamentoTemplate7>
      <p>
        <strong>7.1.</strong> Nenhuma das Partes poderá ser considerada como inadimplente de suas obrigações contratuais
        se tal fato for resultante de caso fortuito ou força maior.
      </p>
      <p>
        <strong>7.2.</strong> As Partes se obrigam por si, seus herdeiros e sucessores a qualquer título e, ao fiel
        cumprimento deste Contrato.
      </p>
    </ng-template>
  </div>

  <div class="clause">
    <h2>Cláusula Oitava – FORO E ASSINATURA</h2>
    <p *ngIf="possuiAverbacao || !contratoSemPagamento">
      <strong>8.1.</strong> As PARTES declaram que o início efetivo da prestação de serviços, bem como de todas as
      demais obrigações oriundas deste instrumento, será considerada a data de pagamento da entrada e/ou da primeira
      parcela, ANEXO II – DISPOSIÇÕES FINANCEIRAS.
    </p>
    <p>
      <strong>{{ !possuiAverbacao && contratoSemPagamento ? '8.1.' : '8.2.' }}</strong> Para dirimir quaisquer
      controvérsias oriundas deste Contrato, as Partes elegem o Foro da Comarca de ...., Estado ......
    </p>
    <p>
      <strong>{{ !possuiAverbacao && contratoSemPagamento ? '8.2.' : '8.3.' }}</strong> As <strong>PARTES</strong>, de
      forma irrevogável e irretratável, afirmam e declaram que o presente instrumento poderá ser assinado
      eletronicamente mediante: (i) impressão, assinatura e digitalização e reenvio deste termo; (ii) envio de código
      por e-mail cadastrado; (iii) envio de código por mensagem de celular ou Whatsapp cadastrado; ou (iv) envio de foto
      segurando o documento pessoal. Seja qual for a forma escolhida{{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, as <strong>PARTES</strong> a consideram válida e
      aceita, com fundamento no art. 10º, §2º da MP 2200-2/2001, e do art. 6º do Decreto 10.278/2020, sendo a forma que
      for, as assinaturas serão consideradas válidas, vinculantes e executáveis, desde que firmadas pelos representantes
      legais das <strong>PARTES</strong>.
    </p>
    <p>
      E, por estarem assim, justas e contratadas, firmam o presente Contrato em 2 (duas) vias de igual teor e forma, na
      na presença das testemunhas abaixo, para que produza seus regulares efeitos de direito.
    </p>

    <p>{{ cadastro?.projetoMunicipio }}, {{ cadastro?.contractDate | date: 'longDate'}}.</p>
  </div>

  <div class="contract__subscription" *ngIf="isPrint">
    <div class="contract__subscription__table">
      <div class="contract__subscription__column">
        <p>______________________________________________</p>
        <p>CONTRATANTE/OUTORGANTE</p>
        <div class="contract__subscription__column__infos">
          <p>Representante: {{ proprietario?.name }}</p>
          <p>CPF: {{ proprietario?.cpf }}</p>
        </div>
      </div>
      <div class="contract__subscription__column contract__subscription__column--no-border-left">
        <img class="contract__ceo-subscription" alt="Assinatura CEO" src="/assets/images/assinatura.svg" />
        <p>______________________________________________</p>
        <p>NATHALIE ROMANO</p>
        <div class="contract__subscription__column__infos">
          <p>USUCAMPEÃO</p>
          <p>CNPJ: 36.174.049/0001-08</p>
        </div>
      </div>
      <div class="contract__subscription__column contract__subscription__column--no-border-top">
        <p>______________________________________________</p>
        <div class="contract__subscription__column__infos">
          <p>Testemunha 1: _______________________________</p>
          <p>CPF:</p>
        </div>
      </div>

      <div class="contract__subscription__column contract__subscription__column--no-border-top">
        <p>______________________________________________</p>
        <div class="contract__subscription__column__infos">
          <p>Testemunha 2: _______________________________</p>
          <p>CPF:</p>
        </div>
      </div>
    </div>
  </div>

  <div class="anexo">
    <h2>ANEXO I</h2>
    <h3>ESCOPO DO SERVIÇO</h3>
    <p>
      <strong>1.1.</strong> Análise detalhada do imóvel e da posse, as medidas jurídicas, urbanísticas, ambientais e
      sociais com a finalidade de incorporar o imóvel informal ao ordenamento territorial urbano do município com a sua
      consequente titulação.
    </p>
    <p><strong>1.2.</strong> Ingresso com processo administrativo de REURB, perante a municipalidade.</p>
    <p>
      <strong>1.3.</strong> Elaboração do Projeto de Regularização Fundiária, conforme o artigo 30 do Decreto Federal nº
      9.310 de 2018, e artigo 35 da Lei Federal 13.465 de 16 de julho de 2017:
    </p>
    <ul>
      <li>
        <strong>1.3.1.</strong> Levantamento planialtimétrico e cadastral com georreferenciamento, que demonstrará as
        unidades, as construções, o sistema viário, as áreas públicas, os acidentes geográficos e os demais elementos
        caracterizadores do núcleo a ser regularizado;
      </li>
      <li><strong>1.3.2.</strong> Estudo das desconformidades e da situação jurídica, urbanística e ambiental;</li>
      <li><strong>1.3.3.</strong> Projeto urbanístico;</li>
      <li><strong>1.3.4.</strong> Memorial descritivo do imóvel;</li>
      <li>
        <strong>1.3.5.</strong> Elaboração de cronograma físico de serviços e de obras de infraestrutura essencial,
        compensações urbanísticas, ambientais, com orientação referente às responsabilidades decorrentes da Assinatura
        de Termo de Compromisso se for o caso;
      </li>
      <li>
        <strong>1.3.6.</strong> Toda a gestão de processo administrativo, tanto na Prefeitura, até a conclusão de CRF
        (Certidão de Regularidade Fundiária), quanto no Cartório de Registro até expedição da titulação definitiva, que
        poderão ser acompanhadas pelo site: www.usucampeao.com.br ou através do app “Voce pode Regularizar” com as
        seguintes funcionalidades:
        <ul>
          <li><strong>1.3.6.1.</strong> Sistema de gestão seguro com login e senha na Plataforma digital;</li>
          <li>
            <strong>1.3.6.2.</strong> Possibilidade de realizar o cadastramento dos dados pessoais e da posse da
            propriedade;
          </li>
          <li>
            <strong>1.3.6.3.</strong> Serviços de mensagem para fornecer informações sobre o andamento do processo com
            os
            ocupantes;
          </li>
          <li>
            <strong>1.3.6.4.</strong> Serviços de inclusão de documentos pessoais e que comprovam a posse da
            propriedade.
          </li>
          <li *ngIf="possuiAverbacao || !contratoSemPagamento">
            <strong>1.3.6.5.</strong> Sistema de meios de pagamento dos valores do serviço através da plataforma,
            através de cartão de crédito e boleto bancário.
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <div class="anexo" *ngIf="possuiAverbacao || !contratoSemPagamento">
    <h2>ANEXO II</h2>
    <h3>DISPOSIÇÕES FINANCEIRAS</h3>
    <p>
      <strong>1.1.</strong> Este termo estabelece as DISPOSIÇÕES FINANCEIRAS entre a USUCAMPEÃO e
      {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      para a realização dos serviços de regularização fundiária “REURB” celebrados no respectivo instrumento.
    </p>
    <p>
      <strong>1.2.</strong> Pela prestação de serviços objeto do presente instrumento firmado entre as partes,
      {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'pagarão' : 'pagará' }} a quantia de {{ cadastro.valorServico | currency: 'BRL' }}
      ({{cadastro?.valorServico | numeroExtenso: numeroExtensoTipo.MONETARIO}}).
    </p>
    <p>
      <strong>1.3.</strong> Será aplicado desconto de {{ cadastro.descontoPorcentagem || 0 }}%
      ({{cadastro?.descontoPorcentagem | numeroExtenso: numeroExtensoTipo.PORCENTAGEM}}), referente à:
    </p>
    <ul>
      <li>Evento ( )</li>
      <li>Campanha ( )</li>
      <li>
        Cupom ( {{ cadastro.cupomDescontoCodigo ? 'X' : '' }} )
        <i> {{ cadastro.cupomDescontoCodigo ? cadastro.cupomDescontoCodigo : '' }} </i>
      </li>
      <li>Pagamento à vista ( {{ isPagamentoAVista ? 'X' : '' }} )</li>
    </ul>
    <p><strong>1.4.</strong> A forma de pagamento será:</p>
    <ul>
      <li>Boleto Bancário ( {{ cadastro.meioPagamento === meioPagamento.BOLETO ? 'X' : '' }} )</li>
      <li>Dinheiro ( {{ cadastro.meioPagamento === meioPagamento.PIX ? 'X' : '' }} )</li>
      <li>Cartão ( {{ cadastro.meioPagamento === meioPagamento.CARTAO_CREDITO ? 'X' : '' }} )</li>
      <li>Carnê ( )</li>
    </ul>
    <p>
      <strong>1.5.</strong> A consulta da situação financeira para com os pagamentos poderá ser acessada pelo APP, site
      da USUCAMPEÃO ou ainda {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> via:
    </p>
    <ul>
      <li>Whatsapp para o número (11) 97123-3055; ou</li>
      <li>E-mail para o endereço contato&#64;usucampeao.com.br</li>
    </ul>

    <div class="financial-table">
      <p><strong>2.</strong> Tabela de Valores:</p>

      <usucampeao-tabela-valores [cadastro]="cadastro"></usucampeao-tabela-valores>
    </div>
  </div>
</div>